

















import 'reflect-metadata'
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import { toDCM } from '@/helper'
import Tooltip from '@/components/rows/Tooltip.vue'
import { BlocksGettersMixin } from '@/store/modules/blocks/blocks.mixins'
import { EVMBlockQueryResponse } from '@/store/modules/blocks/models'
import EVMBlockRow from '@/components/Block/EVMBlockRow.vue'

@Component({
    components: {
        Tooltip,
        EVMBlockRow,
    },
    filters: {
        toDCM,
    },
})
export default class EVMBlocks extends Mixins(BlocksGettersMixin) {
    @Prop() blocks!: EVMBlockQueryResponse[]

    get startingBlock() {
        return this.blocks[0]
    }

    get startingBlockNumber() {
        return this.startingBlock.blockNumber || '0'
    }

    get endingBlock() {
        return this.blocks[this.blocks.length - 1]
    }

    get endingBlockNumber() {
        return this.endingBlock.blockNumber || '0'
    }

    get isLoading() {
        return this.isFetching()
    }

    get isTopBlock() {
        return (
            parseInt(this.startingBlockNumber) ===
            parseInt(this.latestBlockNumber)
        )
    }

    get isBottomBlock() {
        return parseInt(this.endingBlockNumber) <= 0
    }

    get latestBlockNumber(): string {
        return (
            (this.$store.state.Blocks.latestBlockNumber as string | null) || '0'
        )
    }
}
